module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/game-621e8cd495c29bd52a78fdd464ec530d.jpg";